module.exports = __webpack_public_path__ + "static/media/download-from-server.39cbc57f.svg";